import { WorkflowHealth } from '@/pages/AgentTrace/health/WorkflowHealth';
import { WINDOW_DAYS_OPTIONS } from '@/pages/AgentTrace/health/windowDays';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';

const WorkflowHealthSearchSchema = z.object({
  windowDays: z.union([z.literal(WINDOW_DAYS_OPTIONS[0]), z.literal(WINDOW_DAYS_OPTIONS[1])]).optional(),
});

const RouteComponent = (): React.ReactNode => {
  // oxlint-disable-next-line no-use-before-define
  const { windowDays } = Route.useSearch();
  // oxlint-disable-next-line no-use-before-define
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <WorkflowHealth
      windowDays={windowDays ?? 7}
      onWindowDaysChange={(next) => {
        void navigate({ search: { windowDays: next }, replace: true });
      }}
    />
  );
};

export const Route = createFileRoute('/_auth/internal/agent-trace/health')({
  component: RouteComponent,
  loader: () => ({ crumb: 'AI workflow health' }),
  validateSearch: WorkflowHealthSearchSchema,
});
